/* global window:true */
/* eslint no-underscore-dangle: 0 */
import { routerMiddleware } from 'react-router-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import { createBrowserHistory } from 'history';
// import { syncHistoryWithStore } from 'react-router-redux';
import thunk from 'redux-thunk';
import rootReducer from './reducers/index';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const history = createBrowserHistory();
const middleware = applyMiddleware(routerMiddleware(history), thunk);

const store = createStore(rootReducer, composeEnhancers(middleware));

export default store;



// WEBPACK FOOTER //
// ./src/store.js